import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeIcon from '../../components/NodeIcon';
import NodeHeader from '../NodeHeader';
import NodeWrapper from '../NodeWrapper';

export default function PersonalVoicemailNode(): React.ReactElement {
  const translate = useTranslate();

  return (
    <NodeWrapper>
      <NodeHeader
        icon={<NodeIcon name='personal_voicemail' />}
        title={translate('callflows.nodes.personal_voicemail.name')}
      />
      <Handle type='target' position={Position.Left} id='personal-voicemail-target' />
    </NodeWrapper>
  );
}
